<template>
	<div class="patient">
		<md-card>
			<md-card-header>
				<div class="md-title">{{patient.name}}</div>
				<div class="md-subhead">{{$t("admin.patientspage")}}</div>
			</md-card-header>

			<md-card-content v-if="patient.patientData">
				<section class="row">
					<div>
						<img class="avatar" :src="patient.avatar"/>
					</div>
					<div class="col-md-10">
						<b>Életkor:</b> {{patient.patientData.age}}</br>
						<b>E-mail:</b> <a :href="'mailto:' + patient.email">{{patient.email}}</a></br>
						<b>{{$t("admin.mothersname")}}</b> {{patient.patientData.mothersName}}</br>
						<b>{{$t("admin.socialsecuritynumber")}}</b> {{patient.patientData.socialSecurity}}</br>
					</div>
				</section>

				<b>{{$t("admin.medicines")}}</b>
				<section class="row">
					<div class="medication col-md-4" v-for="medication in patient.patientData.medication">
						<div class="content">
							Név: <b>{{medication.name}}</b></br>
							Kategória: {{medication.category}}</br>
							Forma: {{medication.form}}</br>
							Felírt mennyiség: {{medication.frequencyUnit}} x {{medication.frequencyVal}} adag</br>
							Hatóanyag: {{medication.doseVal ? medication.doseVal : 'Nincs megadva'}}</br>
						</div>
					</div>
				</section>
			</md-card-content>

			<md-card-actions>
				<md-button :href="pdfUrl()" target="_blank">{{$t("admin.printsummary")}}</md-button>
				<md-button v-on:click="notifyPatient()">{{$t("admin.findinspector")}}</md-button>
			</md-card-actions>
		</md-card>

		<md-whiteframe md-elevation="2">
			<md-tabs>
				<md-tab id="monthly" :md-label="$t('admin.monthlyReport')">

					<div class="row interval">
						<span class="col-xs-4"><md-button v-on:click="reportDate.subtract(1, 'months');loadReport();" class="md-primary"><md-icon>keyboard_arrow_left</md-icon>Előző hónap</md-button></span>
						<span class="col-xs-4"><md-button>Megjelenített hónap: {{reportDate.format("YYYY MMMM") }}</md-button></span>
						<span class="col-xs-4"><md-button v-if="reportDate.isBefore(now)" v-on:click="reportDate.add(1, 'months');loadReport();" class="md-primary">Következő hónap<md-icon>keyboard_arrow_right</md-icon></md-button></span>
					</div>

					<md-card>
						<md-card-header>
							<div class="md-title">{{$t("admin.rescueMedSymptom")}}</div>
						</md-card-header>

						<md-card-content>
							<bar-chart :values="dailyMedications"></bar-chart>
						</md-card-content>
					</md-card>

					<md-table-card>
						<md-table md-sort="title" md-sort-type="desc" @sort="onSort">
							<md-table-header>
								<md-table-row>
									<md-table-head md-sort-by="title">{{$t("admin.factor")}}</md-table-head>
									<md-table-head md-sort-by="value">{{$t("admin.value")}}</md-table-head>
									<md-table-head>{{$t("admin.tendency")}}</md-table-head>
								</md-table-row>
							</md-table-header>

							<md-table-body>
								<md-table-row v-for="(factor, index) in data.factors" :key="index" :md-item="factor">
									<md-table-cell :key="'title'" :md-numeric="false">{{factor.title}}</md-table-cell>
									<md-table-cell :key="'value'" :md-numeric="false">
										<span v-if="factor.unit === 'frequency'">Főként: {{$t(factor.value)}}</span>
										<span v-else>{{$t(factor.value)}} {{$t(factor.unit)}}</span>
									</md-table-cell>
									<md-table-cell>~</md-table-cell>
								</md-table-row>
							</md-table-body>
						</md-table>
					</md-table-card>

					<md-card>
						<md-card-header>
							<div class="md-title">Szöveges megjegyzések</div>
						</md-card-header>

						<md-card-content>
							<div v-for="comment in data.comments">
								<div class="content">
									<h3>{{toShortDate(comment.updatedAt)}}</h3>
									<p>{{comment.value}}</p>
								</div>
							</div>
						</md-card-content>
					</md-card>

				</md-tab>

				<md-tab id="daily" :md-label="$t('admin.dailyReport')">
					<vue-event-calendar :events="measurementEvents">
						<template scope="props">
							<div v-for="(measurement, index) in props.showEvents" class="event-item">
								<b>Type:</b> {{$t(measurement.type)}}<br>
								<b>Value:</b> {{$t(measurement.value)}}<br>
								<b>Time:</b> {{timeFromDate(measurement.updatedAt)}}
							</div>
						</template>
					</vue-event-calendar>
				</md-tab>

			</md-tabs>
		</md-whiteframe>
	</div>
</template>

<script>
	import Api from '../../../generated'
	import BarChart from '../Graphics/BarChart'
	import _ from 'lodash'
	import moment from 'moment'
	import Vue from 'vue'

	var medicationConfig = {
		"category.rescue": "Tüneti szer",
		"category.control": "Kontroll szer",
		"category.other": "Egyéb",
		"form.inhaler": "Spray",
		"form.powder": "Inhalációs por",
		"form.pill": "Tabletta",
		"form.liquid": "Folyadék",
		"freq.dailyOne": "Napi egy",
		"freq.dailyTwo": "Napi kettő",
		"freq.dailyThree": "Napi három",
		"freq.dailyFour": "Napi négy",
		"freq.other": "Egyéb",
		"freq.asNeeded": "Szükség esetén"
	};

	export default {
		components: {
			BarChart
		},
		data(){
			return {
				test1: "Test1",
				test2: "Test2",
				patient: {},
				data: {},
				medicationValues: {},
				sort: {},
				reportDate: moment(),
				now: moment(),
				measurementEvents:[],
				dailyMedications:{}
			}
		},
		methods: {
			onSort(sort){
				this.sort = sort;
				this.data.factors = _.sortByOrder(this.data.factors, this.sort.name, this.sort.type);
			},
			pdfUrl(){
				return Api.ApiClient.instance.apiClient.basePath + "/patient/health/pdf?patientId=" + this.$route.params.id + "&languageId=" + this.$i18n.locale;
			},
			notifyPatient(){
				Api.ApiClient.instance.postNotification({patientId: this.$route.params.id, notificationType : 'survey'}, (error, data, response) => {
					if (error) {
						console.error(error);
					} else {
						console.log(data);
						this.$bus.$emit('showToast','Figyelmeztetés elküldve')
					}
				})
			},
			toShortDate(val){
				return moment(val).format('YYYY.MM.DD.');
			},
			timeFromDate(val){
				return moment(val).format('HH:mm');
			},
			loadReport(){
				Api.ApiClient.instance.getReport({patientId: this.$route.params.id, fromDate: this.reportDate.startOf('month').toISOString(), toDate:  this.reportDate.endOf('month').toISOString()}, (error, data, response) => {
					if (error) {
						console.error(error);
					} else {
						console.log(data)
						if(data.profile.patientData && data.profile.patientData.medication){
							for(var medication of data.profile.patientData.medication){
								medication.category = medicationConfig[medication.category];
								medication.form = medicationConfig[medication.form];
								medication.frequencyUnit = medicationConfig[medication.frequencyUnit];
							}
						}
						
						this.patient = data.profile;
						this.data = data;
						this.medicationValues = data.medicationGraph;
						this.measurementEvents = _.map(data.measurements, (m) => {
							m.date = moment(m.updatedAt).format("YYYY/MM/DD");
							m.title = "Measurement";
							return m;
						});


						// Calculate medication days						
						let startDay = this.reportDate.clone().startOf('month');
						let endDay = this.reportDate.clone().endOf('month');
						var day = startDay.clone();
						var graphDays = {};

						var medications = _.filter(data.measurements, (m) => {
							return (m.type === "medicationUsage" && m.value && moment(m.updatedAt).isBetween(startDay, endDay));
						});

						var symptoms = _.filter(data.measurements, (m) => {
							return (m.type === "symptom" && m.value && m.value == "true" && moment(m.updatedAt).isBetween(startDay, endDay));
						});

						// Bad workaround: make medications from symptoms
						// TODO: clean this mess
						_.map(symptoms, (s) => {
							s.type = "medicationUsage";
							s.subType = this.$t('admin.symptom');
							s.value = 1;
							medications.push(s);
						});

						console.log("MED");
						console.log(JSON.stringify(medications));

						medications = _.map(medications, (m) => {
							m.value = parseInt(m.value);
							return m;
						})

						let medicationTypes = _.uniq(_.map(medications, "subType"));
						var dayGroup = _.groupBy(medications, (m) => {
							return moment(m.updatedAt).startOf("day");
						});

						dayGroup = _.mapValues(dayGroup, (v) => {
							return _.mapValues(_.groupBy(v,"subType"),(v)=>{
								return _.sumBy(v,"value");
							});
						});

						while(day.isBefore(endDay)){
							day = day.add(1, "day");
							
							let valz = {};

							for(let medDay in dayGroup){
								if(moment(medDay).isSame(day,"day")){
									valz = dayGroup[medDay];
								}
							}

							for(let type of medicationTypes){
								if(!_.has(valz, type)){
									valz[type] = 0;
								}
							}

							graphDays[day.clone().format("YYYY-MM-DD")] = valz;
						}

						console.log("OK");
						console.log(graphDays);

						this.dailyMedications = graphDays;


						/*
						demoEvents: [{
							date: '2016/12/15',
							title: 'eat',
							desc: 'longlonglong description'
						},{
							date: '2016/11/12',
							title: 'this is a title'
						}]
						*/
					}
				});
			}
		},
		mounted(){
			this.loadReport();
		}
	}
</script>

<style scoped>
	.avatar{
		width: 100px;
		height: 100px;
	}
	.content {
		margin: 8px;
		background-color: #eee;
		padding: 8px;
	}
	.interval{
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// Patient.vue?1627bfe2